
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';

@Component({
    selector: 'ah-tab-bar',
    templateUrl: './tab-bar.component.html',
    styleUrls: ['./tab-bar.component.scss'],
    standalone: false
})
export class TabBarComponent {

    @Input() tabs: MenuItem[] = [];
    @Input() activeTab: MenuItem;
    @Input() styleClass = '';
    @Input() isStudioReadOnly? = false;
    @Input() makeReadOnlyVisible? = false;

    // Make output consistent with what MenuItem.command expects to receive
    @Output() activeTabChange = new EventEmitter<{ item: MenuItem }>();
    @Output() updateStudio = new EventEmitter<boolean>();

    @ViewChild('menu') menuCmp!: Menu;

    // IMPORTANT: use label (not "0"/"1") to control the selected tab in p-tabs
    get activeValue(): string {
        return this.activeTab?.label ?? this.tabs[0]?.label ?? '';
    }

    makeStudioReadOnly(isStudioReadOnly: boolean) {
        this.updateStudio.emit(isStudioReadOnly);
    }

    onTabValueChange(newValue: string) {
        const selectedTab = this.tabs.find(t => t.label === newValue) ?? null;
        if (!selectedTab) {
            this.menuCmp?.hide?.();
            return;
        }

        selectedTab.command?.({ item: selectedTab, originalEvent: null });
        this.activeTabChange.emit({ item: selectedTab });
        this.menuCmp?.hide?.();
    }
}